import { GALLERY_SERVICE } from "@/services/gallery.service.js";

const state = {postGalleryOutput: false, getGalleryOutput: {}, deleteGalleryByIdOutput: false};

const actions = {
    //Service to create gallery items
    postGallery({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postGalleryRequest');

        GALLERY_SERVICE.postGallery(input)
            .then(
                output => {
                    commit('postGallerySuccess', output);
                },
                error => {
                    commit('postGalleryFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated gallery items
    getGallery({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getGalleryRequest');

        GALLERY_SERVICE.getGallery(queryParams)
            .then(
                output => {
                    commit('getGallerySuccess', output);
                },
                error => {
                    commit('getGalleryFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove gallery items
    deleteGalleryById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteGalleryByIdRequest');

        GALLERY_SERVICE.deleteGalleryById(queryParams)
            .then(
                output => {
                    commit('deleteGalleryByIdSuccess', output);
                },
                error => {
                    commit('deleteGalleryByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postGallery
    postGalleryRequest(state) {
        state.postGalleryOutput = null;
    },
    postGallerySuccess(state, output) {
        state.postGalleryOutput = true;
    },
    postGalleryFailure(state) {
        state.postGalleryOutput = false;
    },

    //getGallery
    getGalleryRequest(state) {
    },
    getGallerySuccess(state, output) {
        state.getGalleryOutput = output;
    },
    getGalleryFailure(state) {
        state.getGalleryOutput = false;
    },

    //deleteGalleryById
    deleteGalleryByIdRequest(state) {
        state.deleteGalleryByIdOutput = null;
    },
    deleteGalleryByIdSuccess(state, output) {
        state.deleteGalleryByIdOutput = true;
    },
    deleteGalleryByIdFailure(state) {
        state.deleteGalleryByIdOutput = false;
    },
};

export const gallery = {
    namespaced: true,
    state,
    actions,
    mutations
};